function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

// Shopify editor
function editorShopifyEvent(t, e, i) {
  let n = !1;
  t.type.includes("shopify:section")
    ? e.hasAttribute("data-section-id") &&
      e.getAttribute("data-section-id") === t.detail.sectionId &&
      (n = !0)
    : t.type.includes("shopify:block") && t.target === e && (n = !0),
    n && i(t);
}

// Shopify Currency Symbol
const currencySymbol = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "Tk",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$",
};
const shopCurrencySymbol = currencySymbol[Shopify.currency.active];

/* Get Sibling */
const getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

/* Slide Up */
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* Slide Down */
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

// Get window top offset
function TopOffset(el) {
  let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
    const cookieConsentMessage = this.querySelector(".cookieconsent-optout-marketing");
   if (cookieConsentMessage) {
      cookieConsentMessage.style.display = "none";
    }
    // Bind event listener for the play button click
    poster.addEventListener("click", this.handleMediaClick.bind(this));
  }

  handleMediaClick() {
    window.pauseAllMedia();
    
    // Show the cookie consent message on the first click if the cookie is not accepted
    const cookieConsentMessage = this.querySelector(".cookieconsent-optout-marketing");
    if (cookieConsentMessage) {
      cookieConsentMessage.style.display = "block";
    }

    // Call the loadContent function to load the actual media content
    this.loadContent();
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class DataCountdown extends HTMLElement {
  constructor() {
    super();

    this.onCountDown();
  }

  onCountDown() {
    const CountDownElement = this.querySelector("[data-countdown]");

    if (CountDownElement) {
      const countDownItem = (value, label) => {
        return `<div class="countdown-item ${label}"><div class="countdown__inner"><span class="countdown__digit">${value}</span> <span class="countdown__labels">${label}</span></div></div>`;
      };
      const date = new Date(
          CountDownElement.getAttribute("data-countdown")
        ).getTime(),
        second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
      const countDownInterval = setInterval(function () {
        let currentTime = new Date().getTime(),
          timeDistance = date - currentTime,
          daysValue = Math.floor(timeDistance / day),
          hoursValue = Math.floor((timeDistance % day) / hour),
          minutesValue = Math.floor((timeDistance % hour) / minute),
          secondsValue = Math.floor((timeDistance % minute) / second);

        CountDownElement.innerHTML =
          countDownItem(daysValue, window.countdown.days) +
          countDownItem(hoursValue, window.countdown.Hours) +
          countDownItem(minutesValue, window.countdown.minutes) +
          countDownItem(secondsValue, window.countdown.second);

        if (timeDistance < 0) clearInterval(countDownInterval);
      }, 1000);
    }
  }
}
customElements.define("countdown-timer", DataCountdown);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("[grid-recommendation]");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.querySelector("[grid-recommendation]").innerHTML =
              recommendations.innerHTML;
          }

          if (recommendations) {
            if (recommendations.innerHTML.trim().length === 0) {
              this.parentElement.classList.add("no-js-inline");
            } else {
              this.children[0].classList.remove("no-js-inline");
            }
          }

          if (html.querySelector(".product-grid-item")) {
            this.classList.add("product-recommendations--loaded");
          }

          if (this.dataset.intent == "complementary") {
            let complementaryProducts = new Swiper(
              this.querySelector(".complementory--slider"),
              {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                autoHeight: true,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
              }
            );
            this.querySelector(
              ".complementary-slideshow--slider"
            ).classList.remove("no-js-inline");

            this.querySelector("details")
              ? (this.querySelector("details").open = true)
              : null;
          }

          if (this.dataset.intent == "related") {
            let autoplay = false,
              sliderAutoplay = this.dataset.autoplay,
              autoPlayValue = false,
              autoPlayTime = parseInt(this.dataset.autoplayTime),
              sliderContainer = true;
            if (sliderAutoplay == "true") {
              autoPlayValue = {
                delay: autoPlayTime,
              };
            }
            if (this.dataset.sliderEnable !== "true") {
              sliderContainer = false;
            }

            let relatedProducts = new Swiper(
              this.querySelector(".productSlider"),
              {
                loop: true,
                slidesPerView: parseInt(this.dataset.showMobile),
                spaceBetween: 30,
                autoplay: autoPlayValue,
                pagination: {
                  el: this.querySelector(".swiper-pagination"),
                  clickable: true,
                  type: "fraction",
                },
                navigation: {
                  nextEl: this.querySelector(".swiper-button-next"),
                  prevEl: this.querySelector(".swiper-button-prev"),
                },
                breakpoints: {
                  640: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  750: {
                    slidesPerView: parseInt(this.dataset.showMobile),
                  },
                  992: {
                    slidesPerView: parseInt(this.dataset.showExtraLarge),
                  },
                },
              }
            );

            if (sliderContainer && sliderAutoplay == "true") {
              this.querySelector(".productSlider").addEventListener(
                "mouseenter",
                (e) => {
                  relatedProducts.autoplay.stop();
                }
              );
              this.querySelector(".productSlider").addEventListener(
                "mouseleave",
                (e) => {
                  relatedProducts.autoplay.start();
                }
              );
            }

            // Slide thumbnail height
            const slideThumbHeight = () => {
              const proudctThumbnails = this.querySelector(
                ".productSlider"
              ).querySelectorAll(".card--client-height");
              if (proudctThumbnails.length > 0) {
                const productThumbnailHeight = proudctThumbnails[0];
                this.querySelector(
                  ".productSlider"
                ).parentElement.style.setProperty(
                  "--slider-navigation-top-offset",
                  `${productThumbnailHeight.clientHeight / 2}px`
                );
              }
            };
            slideThumbHeight();
            window.addEventListener("resize", () => {
              slideThumbHeight();
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);


class paginationScroll extends HTMLElement{
	constructor(){
		super()
		this.url = this.dataset.url
		this.section = this.dataset.section
		this.pagination_grid = document.querySelector(`[data-pagination-id='${this.section}']`)
		
		this.moreProducts = document.querySelector(`#moreProducts--${this.section}`)
		this.morePopups = document.querySelector(`#morePopups--${this.section}`)
		if(this.morePopups){
			this.popup_wrapper =  this.morePopups.closest(".scrollbar")
		}
		this.loadingSpinner = this.querySelector(`#loading--${this.section}`)
		this.currentPage = Number(this.dataset.page);
		this.nextPage = true;
		this.currentlyLoading = false;
		this.observerOptions = {
			root: null, 
			rootMargin: "400px",
			threshold: 1,
		  };
		this.observer = new IntersectionObserver(this.intersectionCallback.bind(this), this.observerOptions)
		this.observer.observe(this)
	}	
	async loadPagination(){
		let urlParams = new URL(window.location.origin + this.url).searchParams
		let urlPage = Number(urlParams.get("page"))
		if(this.currentPage != urlPage ){

			let response = await fetch(window.location.origin + this.url , {
			method: "get",
			headers: {
				'Content-Type': 'application/json'
			}
		})

		let responseText = await response.text()
		let newPage = new DOMParser().parseFromString(responseText, "text/html")
		
		let newProducts = newPage.querySelectorAll(`[data-pagination-id='${this.section}'] .col`)
		newProducts.forEach(product => {
			this.pagination_grid.insertBefore(product, this.moreProducts)
		})

		if(this.morePopups){
			let newPopups = newPage.querySelectorAll("product-popup")
			newPopups.forEach(popup => {
				this.popup_wrapper.insertBefore(popup, this.morePopups)
			})
		}
		
		if(newPage.querySelector(`#${this.id}`)){
			let newPaginationElement = newPage.querySelector(`#${this.id}`)
			this.nextPage = true
			this.url = newPaginationElement.dataset.url
		}else{
			this.nextPage = false
		}
		this.currentPage = this.currentPage + 1
		}
		
	}
	async paginate(){
		
		
		if(this.nextPage && !this.currentlyLoading){
			this.startLoading()
			await this.loadPagination()
			this.endLoading()
		}
	}
	startLoading(){
		this.currentlyLoading = true;
		this.loadingSpinner.classList.remove("hidden")
	}
	endLoading(){
		this.loadingSpinner.classList.add("hidden")
		this.currentlyLoading = false;
	}
	intersectionCallback(entries) {
		entries.forEach((entry) => {
		  if (entry.isIntersecting) {
			
			this.paginate();
		  }
		});
	  }
	
}

customElements.define("pagination-scroll", paginationScroll)

/**
 * Download Product Images, Files
 */
document.addEventListener('DOMContentLoaded', function() {
  // Select all download links for Produktinfo
  var produktinfoLinks = document.querySelectorAll('[id^="product-info"]');
  
  // Loop through each Produktinfo download link
  produktinfoLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior (navigating)
      
      // Get the product ID associated with this download link
      var productId = this.getAttribute('data-product-id');
      
      // Log to console for debugging purposes
      console.log("Clicked download for Produktinfo:", productId);
      
      // Get the PDF URL from the download link's href attribute
      var pdfUrl = this.getAttribute('href');
      
      // Fetch the PDF blob from the URL
      fetch(pdfUrl)
        .then(response => response.blob())
        .then(blob => {
          // Save the blob as a file using FileSaver.js (assuming you have it included in your project)
          saveAs(blob, productId + '.pdf'); // Use productId as filename (adjust filename as per your requirement)
        })
        .catch(error => {
          console.error('Error downloading Produktinfo:', error);
        });
    });
  });
  
  // Select all download links for Produktbild
  var produktbildLinks = document.querySelectorAll('[id^="product-image"]');
  
  // Loop through each Produktbild download link
  produktbildLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default link behavior (navigating)
      
      // Get the product ID associated with this download link
      var productId = this.getAttribute('data-product-id');
      
      // Log to console for debugging purposes
      console.log("Clicked download for Produktbild:", productId);
      
      // Get the image URL from the download link's href attribute
      var imageUrl = this.getAttribute('href');
      
      // Fetch the image blob from the URL
      fetch(imageUrl)
        .then(response => response.blob())
        .then(blob => {
          // Extract filename from imageUrl
          var filename = extractFilenameFromUrl(imageUrl);
          
          // Save the blob as a file using FileSaver.js (assuming you have it included in your project)
          saveAs(blob, filename); // Use extracted filename as the actual filename
        })
        .catch(error => {
          console.error('Error downloading Produktbild:', error);
        });
    });
  });
});

// Function to extract filename from URL
function extractFilenameFromUrl(url) {
  var startIndex = url.lastIndexOf("/") + 1;
  var endIndex = url.lastIndexOf("?");
  var filename = url.substring(startIndex, endIndex !== -1 ? endIndex : url.length);
  return filename;
}


/**
 * Create PDF Product 
 */
function generatePDF() {
  
}

// mute video
const muteInstagramVideos = () => {
  const videos = document.querySelectorAll('.section-app video');
  if (videos.length) {
    videos.forEach(video => video.muted = true );
  }
}

const observer = new MutationObserver(() => {
  const videos = document.querySelectorAll('.section-app video');

  if (videos.length) {
    muteInstagramVideos();
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});


// Commerce Connector Adjustments
document.addEventListener("DOMContentLoaded", function () {
  const buyButton = document.querySelector(".selection_popup_button");
  
  if (!buyButton) return; // Exit if button is not found

  buyButton.addEventListener("click", function () {
      // add headline

      // Wait a short moment to ensure popup appears
      setTimeout(() => {      
          const popup = document.querySelector(".cc-Popup-module-modalOpened_1DO53");
          console.log("popup:", popup);

          // Create the new heading element
          let heading = document.createElement("div");
          heading.className = "popup_heading h3";
          heading.textContent = "Verfügbar bei";

          // Select the <ul> element
          const resultList = popup.querySelector(".cc-Popup-module-container_kmpXJ .cc-Popup-module-channels_J6AEZ .cc-BNOChannel-module-container_2rn2s .cc-BNOChannel-module-list_kN-fJ");      
          console.log("resultList:", resultList)
          // Insert the heading before the <ul>
          if (resultList && resultList) {
            resultList.insertBefore(heading, resultList.firstChild);
          }
        
          document.head.appendChild(style);


          if (popup) {
              showBlurBackground();
              observePopupClose(popup);
          }
      }, 100);
  });

  function showBlurBackground() {
      // Check if the blur background already exists
      if (!document.querySelector(".cc-background")) {
          const blurDiv = document.createElement("div");
          blurDiv.className = "cc-background";
          document.body.appendChild(blurDiv);
      }
  }

  function removeBlurBackground() {
      const blurDiv = document.querySelector(".cc-background");
      if (blurDiv) {
          blurDiv.remove();
      }
  }

  function observePopupClose(popup) {
      const closeButton = document.getElementById("ccDialogCloseBtn");

      // Observe popup's visibility changes
      const observer = new MutationObserver(() => {
          if (popup.style.display === "none") {
              removeBlurBackground();
          }
      });

      observer.observe(popup, { attributes: true, attributeFilter: ["style"] });

      // Close button event listener
      if (closeButton) {
          closeButton.addEventListener("click", removeBlurBackground);
      }
  }

});
